import { useState } from "react";
import { Button } from "react-bootstrap";
import { BsFillCircleFill, BsFillPatchCheckFill } from "react-icons/bs";
import FormSubmit from "../submit";
import NewAddress from "./insert";

const ViewAddress = (x) => {
  const { onClick, selected = true, refresh } = x;

  return (
    <div
      className={`h-100 border-2 ${false ? " border-info" : ""} list-address`}
    >
      <div className="d-flex justify-content-between mb-3">
        <p className="mb-0 fw-bold fs-6 text-capitalize">{x.name}</p>
        <span className="font-tiny rounded-pill border px-2 py-1 pb-0">
          {x.type}
        </span>
      </div>
      <p className="font-md">
        {x.street}, {x.landMark}, {x.location?.city}, {x.location?.state}, USA,{" "}
        {x.location?.zipcode}
      </p>
      <h2 className="fw-bold font-e-lg">Mobile : {x.mobile || "NA"}</h2>
      <h2 className="fw-bold font-e-lg mb-4">Email : {x.email}</h2>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex">
          <NewAddress
            refresh={x.refresh}
            title={
              <div
                role="button"
                className="text-uppercase font-md fw-bold me-4"
              >
                Edit
              </div>
            }
            update={x}
          ></NewAddress>
          <FormSubmit
            url={"/account/address/delete/" + x.id}
            callback={refresh}
          >
            <Button
              type="submit"
              variant="transparent shadow-none p-0 pb-1 m-0 text-uppercase p-0 m-0 my-0 bg-transparent font-md fw-bold text-danger"
            >
              Delete
            </Button>
          </FormSubmit>
        </div>
        {onClick ? (
          <div
            role="button"
            onClick={onClick}
            className={`bg-${selected ? "dark" : "grey"} rounded-8 px-3 py-1`}
          >
            <span className={`text-white  font-sm `}>Select</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ViewAddress;
